"use client";

import Link from "next/link";
import {Legal} from "~/app/legal/legals";

export function LegalLink({
                            legal,
                            article
                          }: {
  legal: Legal;
  article: number;
}) {
  return (
      <span >
      {" "}
        <Link href={`legal/${legal.location}#article-${article}`}>
            {article}
        </Link>
      </span>
  );
}
